interface ReservationTypeSelectorProps {
  allowMultiDay: boolean;
  onSelect: (value: boolean) => void;
}

export function ReservationTypeSelector({ allowMultiDay, onSelect }: ReservationTypeSelectorProps) {
  return (
    <div>
      <label style={{ display: 'block', marginBottom: '1rem', fontSize: '0.9rem', fontWeight: 600, color: '#00303c' }}>Type de réservation</label>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        <TypeOption 
          label="Mono-date uniquement" 
          description="Le client ne peut réserver que pour une seule journée" 
          checked={!allowMultiDay} 
          onClick={() => onSelect(false)} 
        />
        <TypeOption 
          label="Multi-dates autorisées" 
          description="Le client peut réserver sur plusieurs jours consécutifs" 
          checked={allowMultiDay} 
          onClick={() => onSelect(true)} 
        />
      </div>
    </div>
  );
}

function TypeOption({ label, description, checked, onClick }: any) {
  return (
    <label style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem', padding: '1rem', background: checked ? 'rgba(0,117,141,0.05)' : 'white', border: `2px solid ${checked ? '#00758d' : '#e5e7eb'}`, borderRadius: '12px', cursor: 'pointer' }}>
      <input type="radio" checked={checked} onChange={onClick} style={{ width: '20px', height: '20px', marginTop: '2px', cursor: 'pointer', accentColor: '#00758d' }} />
      <div>
        <div style={{ fontSize: '0.95rem', fontWeight: 600, color: '#00303c', marginBottom: '0.25rem' }}>{label}</div>
        <div style={{ fontSize: '0.85rem', color: '#666' }}>{description}</div>
      </div>
    </label>
  );
}
